<template>
  <v-speed-dial
    v-model="fab"
    top="top"
    right="right"
    direction="left"
    class="fab-help-dial"
    fixed>
    <v-btn
      id="student-help-btn"
      aria-label="student-help"
      slot="activator"
      color="error"
      class="help-btn"
      v-model="fab"
      @click="helpClicked"
      >
      <div>
        <h3 class="help-btn-txt">{{$t('student.help.help')}}</h3>
        <v-icon v-if="!fab" aria-hidden="false">live_help</v-icon>
        <v-icon v-else aria-hidden="false">close</v-icon>
      </div>
    </v-btn>
    <v-dialog v-model="fab" content-class="help-dialog" max-width="450px">
      <v-flex xs12>
        <h3 class="text-xs-center help-dialog-title">{{$t('student.help.article_title')}}</h3>
        <fab-help-button v-for="(buttonKey) in buttons" :key="buttonKey" :button-key="buttonKey" @close-help-popup="closeHelpPopup"/>
      </v-flex>
    </v-dialog>
  </v-speed-dial>
</template>

<script>
  import FabHelpButton from './FabHelpButton'
  import { POST_STUDENT_HELP_POPUP } from '../../../store/action-types'
  import { mapActions } from 'vuex'

  export default {
    components: {FabHelpButton},
    name: 'fab-dial',
    props: {
      buttons: {
        required: true,
        type: Array
      }
    },
    data () {
      return {
        fab: false
      }
    },
    methods: {
      ...mapActions({
        postHelpPopUp: POST_STUDENT_HELP_POPUP
      }),
      helpClicked () {
        if (!this.fab) {
          this.postHelpPopUp()
        }
      },
      closeHelpPopup () {
        this.fab = false
      }
    }
  }
</script>

<style scoped>
  .fab-help-dial {
    transition: all 0.3s ease-out;
    z-index: 4;
    right: -10px;
    top: 240px;
  }

  .help-dialog-title {
    color: white;
  }

  .help-btn {
    height: 130px;
    min-width: 40px;
    width: 40px;
    box-shadow: 0 7px 8px -4px rgba(0,0,0,.2),
                0 12px 17px 2px rgba(0,0,0,.14),
                0 5px 22px 4px rgba(0,0,0,.12);
  }
  .help-btn-txt {
    width:1px;
    word-wrap: break-word;
    white-space: normal;
    padding-left: 7px;
  }
</style>
<style>
  .help-dialog {
    box-shadow: none;
    overflow-y: visible;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/misc/fab/FabHelpDial.vue